export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
    createUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
    updateUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganizationUser = /* GraphQL */ `
  mutation CreateOrganizationUser(
    $input: CreateOrganizationUserInput!
    $condition: ModelOrganizationUserConditionInput
  ) {
    createOrganizationUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateOrganizationUser = /* GraphQL */ `
  mutation UpdateOrganizationUser(
    $input: UpdateOrganizationUserInput!
    $condition: ModelOrganizationUserConditionInput
  ) {
    updateOrganizationUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteOrganizationUser = /* GraphQL */ `
  mutation DeleteOrganizationUser(
    $input: DeleteOrganizationUserInput!
    $condition: ModelOrganizationUserConditionInput
  ) {
    deleteOrganizationUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganizationFivetran = /* GraphQL */ `
  mutation CreateOrganizationFivetran(
    $input: CreateOrganizationFivetranInput!
    $condition: ModelOrganizationFivetranConditionInput
  ) {
    createOrganizationFivetran(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganizationSourceConfigHistory = /* GraphQL */ `
  mutation CreateOrganizationSourceConfigHistory(
    $input: CreateOrganizationSourceConfigHistoryInput!
    $condition: ModelOrganizationSourceConfigHistoryConditionInput
  ) {
    createOrganizationSourceConfigHistory(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganizationTerraformConfigHistory = /* GraphQL */ `
  mutation CreateOrganizationTerraformConfigHistory(
    $input: CreateOrganizationTerraformConfigHistoryInput!
    $condition: ModelOrganizationTerraformConfigHistoryConditionInput
  ) {
    createOrganizationTerraformConfigHistory(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOrganizationAIContext = /* GraphQL */ `
  mutation CreateOrganizationAIContext(
    $input: CreateOrganizationAIContextInput!
    $condition: ModelOrganizationAIContextConditionInput
  ) {
    createOrganizationAIContext(input: $input, condition: $condition) {
      id
      orgId
      industry
      description
      industries
      business
      customers
      mission
      differentiators
      objectives
      companyType
      employeeCount
      foundedDate
      markets
      productsServices
      website
      logoS3Key
      iconS3Key
      logoDarkS3Key
      iconDarkS3Key
      primaryColor
      secondaryColor
      accentColor
      backgroundColor
      surfaceColor
      borderColor
      textColor
      mutedTextColor
      successColor
      warningColor
      errorColor
      additionalInstructions
      defaultIdentityPackId
      updatedBy
      themes
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationAIContext = /* GraphQL */ `
  mutation UpdateOrganizationAIContext(
    $input: UpdateOrganizationAIContextInput!
    $condition: ModelOrganizationAIContextConditionInput
  ) {
    updateOrganizationAIContext(input: $input, condition: $condition) {
      id
      orgId
      industry
      description
      industries
      business
      customers
      mission
      differentiators
      objectives
      companyType
      employeeCount
      foundedDate
      markets
      productsServices
      website
      logoS3Key
      iconS3Key
      logoDarkS3Key
      iconDarkS3Key
      primaryColor
      secondaryColor
      accentColor
      backgroundColor
      surfaceColor
      borderColor
      textColor
      mutedTextColor
      successColor
      warningColor
      errorColor
      additionalInstructions
      defaultIdentityPackId
      updatedBy
      themes
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationAIContext = /* GraphQL */ `
  mutation DeleteOrganizationAIContext(
    $input: DeleteOrganizationAIContextInput!
    $condition: ModelOrganizationAIContextConditionInput
  ) {
    deleteOrganizationAIContext(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createWorkspace = /* GraphQL */ `
  mutation CreateWorkspace(
    $input: CreateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    createWorkspace(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateWorkspace = /* GraphQL */ `
  mutation UpdateWorkspace(
    $input: UpdateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    updateWorkspace(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createWorkspaceUser = /* GraphQL */ `
  mutation CreateWorkspaceUser(
    $input: CreateWorkspaceUserInput!
    $condition: ModelWorkspaceUserConditionInput
  ) {
    createWorkspaceUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateWorkspaceUser = /* GraphQL */ `
  mutation UpdateWorkspaceUser(
    $input: UpdateWorkspaceUserInput!
    $condition: ModelWorkspaceUserConditionInput
  ) {
    updateWorkspaceUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteWorkspaceUser = /* GraphQL */ `
  mutation DeleteWorkspaceUser(
    $input: DeleteWorkspaceUserInput!
    $condition: ModelWorkspaceUserConditionInput
  ) {
    deleteWorkspaceUser(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createSource = /* GraphQL */ `
  mutation CreateSource($input: CreateSourceInput!, $condition: ModelSourceConditionInput) {
    createSource(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateSource = /* GraphQL */ `
  mutation UpdateSource($input: UpdateSourceInput!, $condition: ModelSourceConditionInput) {
    updateSource(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteSource = /* GraphQL */ `
  mutation DeleteSource($input: DeleteSourceInput!, $condition: ModelSourceConditionInput) {
    deleteSource(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createSourceWorkspaceShare = /* GraphQL */ `
  mutation CreateSourceWorkspaceShare(
    $input: CreateSourceWorkspaceShareInput!
    $condition: ModelSourceWorkspaceShareConditionInput
  ) {
    createSourceWorkspaceShare(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDataObject = /* GraphQL */ `
  mutation CreateDataObject(
    $input: CreateDataObjectInput!
    $condition: ModelDataObjectConditionInput
  ) {
    createDataObject(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDataObject = /* GraphQL */ `
  mutation UpdateDataObject(
    $input: UpdateDataObjectInput!
    $condition: ModelDataObjectConditionInput
  ) {
    updateDataObject(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDataObject = /* GraphQL */ `
  mutation DeleteDataObject(
    $input: DeleteDataObjectInput!
    $condition: ModelDataObjectConditionInput
  ) {
    deleteDataObject(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDataset = /* GraphQL */ `
  mutation CreateDataset($input: CreateDatasetInput!, $condition: ModelDatasetConditionInput) {
    createDataset(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDataset = /* GraphQL */ `
  mutation UpdateDataset($input: UpdateDatasetInput!, $condition: ModelDatasetConditionInput) {
    updateDataset(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDataset = /* GraphQL */ `
  mutation DeleteDataset($input: DeleteDatasetInput!, $condition: ModelDatasetConditionInput) {
    deleteDataset(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDatasetTest = /* GraphQL */ `
  mutation CreateDatasetTest(
    $input: CreateDatasetTestInput!
    $condition: ModelDatasetTestConditionInput
  ) {
    createDatasetTest(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDatasetTest = /* GraphQL */ `
  mutation UpdateDatasetTest(
    $input: UpdateDatasetTestInput!
    $condition: ModelDatasetTestConditionInput
  ) {
    updateDatasetTest(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDatasetTest = /* GraphQL */ `
  mutation DeleteDatasetTest(
    $input: DeleteDatasetTestInput!
    $condition: ModelDatasetTestConditionInput
  ) {
    deleteDatasetTest(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDatasetShareFromWorkspaceWithWorkspaceLink = /* GraphQL */ `
  mutation CreateDatasetShareFromWorkspaceWithWorkspaceLink(
    $input: CreateDatasetShareFromWorkspaceWithWorkspaceLinkInput!
    $condition: ModelDatasetShareFromWorkspaceWithWorkspaceLinkConditionInput
  ) {
    createDatasetShareFromWorkspaceWithWorkspaceLink(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDatasetShareFromWorkspaceWithWorkspaceLink = /* GraphQL */ `
  mutation DeleteDatasetShareFromWorkspaceWithWorkspaceLink(
    $input: DeleteDatasetShareFromWorkspaceWithWorkspaceLinkInput!
    $condition: ModelDatasetShareFromWorkspaceWithWorkspaceLinkConditionInput
  ) {
    deleteDatasetShareFromWorkspaceWithWorkspaceLink(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDatasetWorkspaceShare = /* GraphQL */ `
  mutation CreateDatasetWorkspaceShare(
    $input: CreateDatasetWorkspaceShareInput!
    $condition: ModelDatasetWorkspaceShareConditionInput
  ) {
    createDatasetWorkspaceShare(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDatasetWorkspaceShare = /* GraphQL */ `
  mutation DeleteDatasetWorkspaceShare(
    $input: DeleteDatasetWorkspaceShareInput!
    $condition: ModelDatasetWorkspaceShareConditionInput
  ) {
    deleteDatasetWorkspaceShare(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDatasetSqlQuery = /* GraphQL */ `
  mutation CreateDatasetSqlQuery(
    $input: CreateDatasetSqlQueryInput!
    $condition: ModelDatasetSqlQueryConditionInput
  ) {
    createDatasetSqlQuery(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDatasetSqlQuery = /* GraphQL */ `
  mutation UpdateDatasetSqlQuery(
    $input: UpdateDatasetSqlQueryInput!
    $condition: ModelDatasetSqlQueryConditionInput
  ) {
    updateDatasetSqlQuery(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDatasetSqlQuery = /* GraphQL */ `
  mutation DeleteDatasetSqlQuery(
    $input: DeleteDatasetSqlQueryInput!
    $condition: ModelDatasetSqlQueryConditionInput
  ) {
    deleteDatasetSqlQuery(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDatasetVisualization = /* GraphQL */ `
  mutation CreateDatasetVisualization(
    $input: CreateDatasetVisualizationInput!
    $condition: ModelDatasetVisualizationConditionInput
  ) {
    createDatasetVisualization(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDatasetVisualization = /* GraphQL */ `
  mutation UpdateDatasetVisualization(
    $input: UpdateDatasetVisualizationInput!
    $condition: ModelDatasetVisualizationConditionInput
  ) {
    updateDatasetVisualization(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDatasetVisualization = /* GraphQL */ `
  mutation DeleteDatasetVisualization(
    $input: DeleteDatasetVisualizationInput!
    $condition: ModelDatasetVisualizationConditionInput
  ) {
    deleteDatasetVisualization(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createFlow = /* GraphQL */ `
  mutation CreateFlow($input: CreateFlowInput!, $condition: ModelFlowConditionInput) {
    createFlow(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateFlow = /* GraphQL */ `
  mutation UpdateFlow($input: UpdateFlowInput!, $condition: ModelFlowConditionInput) {
    updateFlow(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteFlow = /* GraphQL */ `
  mutation DeleteFlow($input: DeleteFlowInput!, $condition: ModelFlowConditionInput) {
    deleteFlow(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createIntegration = /* GraphQL */ `
  mutation CreateIntegration(
    $input: CreateIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    createIntegration(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateIntegration = /* GraphQL */ `
  mutation UpdateIntegration(
    $input: UpdateIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    updateIntegration(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteIntegration = /* GraphQL */ `
  mutation DeleteIntegration(
    $input: DeleteIntegrationInput!
    $condition: ModelIntegrationConditionInput
  ) {
    deleteIntegration(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createConnection = /* GraphQL */ `
  mutation CreateConnection(
    $input: CreateConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    createConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createOAuthCallback = /* GraphQL */ `
  mutation CreateOAuthCallback(
    $input: CreateOAuthCallbackInput!
    $condition: ModelOAuthCallbackConditionInput
  ) {
    createOAuthCallback(input: $input, condition: $condition) {
      connectionId
    }
  }
`;
export const deleteOAuthCallback = /* GraphQL */ `
  mutation DeleteOAuthCallback(
    $input: DeleteOAuthCallbackInput!
    $condition: ModelOAuthCallbackConditionInput
  ) {
    deleteOAuthCallback(input: $input, condition: $condition) {
      connectionId
    }
  }
`;
export const updateConnection = /* GraphQL */ `
  mutation UpdateConnection(
    $input: UpdateConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    updateConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteConnection = /* GraphQL */ `
  mutation DeleteConnection(
    $input: DeleteConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    deleteConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createFivetranConnection = /* GraphQL */ `
  mutation CreateFivetranConnection(
    $input: CreateFivetranConnectionInput!
    $condition: ModelFivetranConnectionConditionInput
  ) {
    createFivetranConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateFivetranConnection = /* GraphQL */ `
  mutation UpdateFivetranConnection(
    $input: UpdateFivetranConnectionInput!
    $condition: ModelFivetranConnectionConditionInput
  ) {
    updateFivetranConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteFivetranConnection = /* GraphQL */ `
  mutation DeleteFivetranConnection(
    $input: DeleteFivetranConnectionInput!
    $condition: ModelFivetranConnectionConditionInput
  ) {
    deleteFivetranConnection(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createCredentials = /* GraphQL */ `
  mutation CreateCredentials(
    $input: CreateCredentialsInput!
    $condition: ModelCredentialsConditionInput
  ) {
    createCredentials(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateCredentials = /* GraphQL */ `
  mutation UpdateCredentials(
    $input: UpdateCredentialsInput!
    $condition: ModelCredentialsConditionInput
  ) {
    updateCredentials(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteCredentials = /* GraphQL */ `
  mutation DeleteCredentials(
    $input: DeleteCredentialsInput!
    $condition: ModelCredentialsConditionInput
  ) {
    deleteCredentials(input: $input, condition: $condition) {
      id
    }
  }
`;
export const customCreateFolder = /* GraphQL */ `
  mutation CustomCreateFolder($input: CreateFolderInput!, $condition: ModelFolderConditionInput) {
    customCreateFolder(input: $input, condition: $condition) {
      id
    }
  }
`;
export const customUpdateFolder = /* GraphQL */ `
  mutation CustomUpdateFolder($input: UpdateFolderInput!, $condition: ModelFolderConditionInput) {
    customUpdateFolder(input: $input, condition: $condition) {
      id
    }
  }
`;
export const customDeleteFolder = /* GraphQL */ `
  mutation CustomDeleteFolder($input: DeleteFolderInput!, $condition: ModelFolderConditionInput) {
    customDeleteFolder(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDownload = /* GraphQL */ `
  mutation CreateDownload($input: CreateDownloadInput!, $condition: ModelDownloadConditionInput) {
    createDownload(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDownload = /* GraphQL */ `
  mutation UpdateDownload($input: UpdateDownloadInput!, $condition: ModelDownloadConditionInput) {
    updateDownload(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDownload = /* GraphQL */ `
  mutation DeleteDownload($input: DeleteDownloadInput!, $condition: ModelDownloadConditionInput) {
    deleteDownload(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole($input: CreateRoleInput!, $condition: ModelRoleConditionInput) {
    createRole(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole($input: UpdateRoleInput!, $condition: ModelRoleConditionInput) {
    updateRole(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole($input: DeleteRoleInput!, $condition: ModelRoleConditionInput) {
    deleteRole(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createPermission = /* GraphQL */ `
  mutation CreatePermission(
    $input: CreatePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    createPermission(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updatePermission = /* GraphQL */ `
  mutation UpdatePermission(
    $input: UpdatePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    updatePermission(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deletePermission = /* GraphQL */ `
  mutation DeletePermission(
    $input: DeletePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    deletePermission(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createDashboard = /* GraphQL */ `
  mutation CreateDashboard(
    $input: CreateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    createDashboard(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDashboard = /* GraphQL */ `
  mutation UpdateDashboard(
    $input: UpdateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    updateDashboard(input: $input, condition: $condition) {
      id
      name
      workspaceId
      settings
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDashboard = /* GraphQL */ `
  mutation DeleteDashboard(
    $input: DeleteDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    deleteDashboard(input: $input, condition: $condition) {
      id
    }
  }
`;
export const beemAgentFinishUnload = /* GraphQL */ `
  mutation BeemAgentFinishUnload($input: FinishUnloadInput!) {
    beemAgentFinishUnload(input: $input) {
      id
      dataId
      dataTimeStamp
      requesterId
      requester {
        id
        email
        firstName
        lastName
        isActive
      }
      requestTimeStamp
      signedDownloadUrl
    }
  }
`;
export const beemAgentDeployDatasetSqlQuery = /* GraphQL */ `
  mutation BeemAgentDeployDatasetSqlQuery($input: DeployDatasetSqlQueryInput!) {
    beemAgentDeployDatasetSqlQuery(input: $input) {
      id
    }
  }
`;
export const fivetranCreateGroup = /* GraphQL */ `
  mutation FivetranCreateGroup($input: FivetranCreateGroupInput!) {
    fivetranCreateGroup(input: $input) {
      id
      groupId
    }
  }
`;
export const modifyFlow = /* GraphQL */ `
  mutation ModifyFlow($input: ModifyFlowInput) {
    modifyFlow(input: $input) {
      placeholder
    }
  }
`;
export const updateIDatasetUser = /* GraphQL */ `
  mutation UpdateIDatasetUser($input: UpdateIDatasetUserInput!) {
    updateIDatasetUser(input: $input) {
      id
    }
  }
`;
export const createIDatasetUser = /* GraphQL */ `
  mutation CreateIDatasetUser($input: CreateIDatasetUserInput!) {
    createIDatasetUser(input: $input) {
      id
    }
  }
`;
export const createDashboardWidget = /* GraphQL */ `
  mutation CreateDashboardWidget(
    $input: CreateDashboardWidgetInput!
    $condition: ModelDashboardWidgetConditionInput
  ) {
    createDashboardWidget(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateDashboardWidget = /* GraphQL */ `
  mutation UpdateDashboardWidget(
    $input: UpdateDashboardWidgetInput!
    $condition: ModelDashboardWidgetConditionInput
  ) {
    updateDashboardWidget(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteDashboardWidget = /* GraphQL */ `
  mutation DeleteDashboardWidget(
    $input: DeleteDashboardWidgetInput!
    $condition: ModelDashboardWidgetConditionInput
  ) {
    deleteDashboardWidget(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createUserPreferenceDashboard = /* GraphQL */ `
  mutation CreateUserPreferenceDashboard(
    $input: CreateUserPreferenceDashboardInput!
    $condition: ModelUserPreferenceDashboardConditionInput
  ) {
    createUserPreferenceDashboard(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateUserPreferenceDashboard = /* GraphQL */ `
  mutation UpdateUserPreferenceDashboard(
    $input: UpdateUserPreferenceDashboardInput!
    $condition: ModelUserPreferenceDashboardConditionInput
  ) {
    updateUserPreferenceDashboard(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createGenerativeDashboard = /* GraphQL */ `
  mutation CreateGenerativeDashboard(
    $input: CreateGenerativeDashboardInput!
    $condition: ModelGenerativeDashboardConditionInput
  ) {
    createGenerativeDashboard(input: $input, condition: $condition) {
      id
      name
      workspaceId
      prompt
      status
      createdBy
      createdAt
      updatedAt
    }
  }
`;

export const updateGenerativeDashboard = /* GraphQL */ `
  mutation UpdateGenerativeDashboard(
    $input: UpdateGenerativeDashboardInput!
    $condition: ModelGenerativeDashboardConditionInput
  ) {
    updateGenerativeDashboard(input: $input, condition: $condition) {
      id
      name
      workspaceId
      prompt
      conversationHistory
      renderContent
      publishedRenderContent
      editVersions
      publishedVersions
      drilldownScript
      drilldownStatus
      wiringScript
      progressStep
      status
      errorMessage
      createdBy
      createdAt
      updatedAt
    }
  }
`;

export const deleteGenerativeDashboard = /* GraphQL */ `
  mutation DeleteGenerativeDashboard(
    $input: DeleteGenerativeDashboardInput!
    $condition: ModelGenerativeDashboardConditionInput
  ) {
    deleteGenerativeDashboard(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createGenerativeDashboardWidget = /* GraphQL */ `
  mutation CreateGenerativeDashboardWidget(
    $input: CreateGenerativeDashboardWidgetInput!
    $condition: ModelGenerativeDashboardWidgetConditionInput
  ) {
    createGenerativeDashboardWidget(input: $input, condition: $condition) {
      id
      dashboardId
      workspaceId
      status
      createdAt
      updatedAt
    }
  }
`;

export const updateGenerativeDashboardWidget = /* GraphQL */ `
  mutation UpdateGenerativeDashboardWidget(
    $input: UpdateGenerativeDashboardWidgetInput!
    $condition: ModelGenerativeDashboardWidgetConditionInput
  ) {
    updateGenerativeDashboardWidget(input: $input, condition: $condition) {
      id
      dashboardId
      workspaceId
      sqlQuery
      queryResult
      datasetIds
      widgetPrompt
      status
      createdAt
      updatedAt
    }
  }
`;

export const deleteGenerativeDashboardWidget = /* GraphQL */ `
  mutation DeleteGenerativeDashboardWidget(
    $input: DeleteGenerativeDashboardWidgetInput!
    $condition: ModelGenerativeDashboardWidgetConditionInput
  ) {
    deleteGenerativeDashboardWidget(input: $input, condition: $condition) {
      id
    }
  }
`;

export const mintEmbedToken = /* GraphQL */ `
  mutation MintEmbedToken($input: MintEmbedTokenInput!) {
    mintEmbedToken(input: $input) {
      token
      expiresAt
    }
  }
`;
export const createBillingPortalSession = /* GraphQL */ `
  mutation CreateBillingPortalSession($query: CreateBillingPortalSessionInput) {
    createBillingPortalSession(query: $query) {
      accessUrl
      expiresAt
    }
  }
`;

// AI Insights conversations and projects, per user and workspace (BEEM-1448).
export const createInsightConversation = /* GraphQL */ `
  mutation CreateInsightConversation($input: CreateInsightConversationInput!) {
    createInsightConversation(input: $input) {
      id
      userId
      workspaceId
      title
      messages
      messageCount
      traces
      projectId
      originKey
      sessionId
      shared
      createdByName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const updateInsightConversation = /* GraphQL */ `
  mutation UpdateInsightConversation($input: UpdateInsightConversationInput!) {
    updateInsightConversation(input: $input) {
      id
      userId
      workspaceId
      title
      messages
      messageCount
      traces
      projectId
      originKey
      sessionId
      shared
      createdByName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteInsightConversation = /* GraphQL */ `
  mutation DeleteInsightConversation($input: DeleteInsightConversationInput!) {
    deleteInsightConversation(input: $input) {
      id
    }
  }
`;
export const createInsightProject = /* GraphQL */ `
  mutation CreateInsightProject($input: CreateInsightProjectInput!) {
    createInsightProject(input: $input) {
      id
      ownerId
      workspaceId
      name
      description
      instructions
      knowledge
      datasetIds
      shared
      ownerName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const updateInsightProject = /* GraphQL */ `
  mutation UpdateInsightProject($input: UpdateInsightProjectInput!) {
    updateInsightProject(input: $input) {
      id
      ownerId
      workspaceId
      name
      description
      instructions
      knowledge
      datasetIds
      shared
      ownerName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteInsightProject = /* GraphQL */ `
  mutation DeleteInsightProject($input: DeleteInsightProjectInput!) {
    deleteInsightProject(input: $input) {
      id
    }
  }
`;
